import type { ApiEnrichmentMention, ApiMention } from '../../lib/mentions.js';
import { ProjectEvidenceBody } from './project-evidence-body.js';

// The citations behind a related record, indented under its name when the row expands.

export function InlineEvidence({
  entityName,
  enrichment,
  mentions,
  isLoading,
}: {
  entityName?: string;
  enrichment: ApiEnrichmentMention[];
  mentions: ApiMention[];
  isLoading: boolean;
}) {
  return (
    <div data-inline-evidence="" className="pb-3 pl-[3.25rem] pr-2 pt-1">
      <ProjectEvidenceBody
        entityName={entityName}
        enrichment={enrichment}
        mentions={mentions}
        isLoading={isLoading}
      />
    </div>
  );
}
